import Questionnaire from '@/pages/questionnaire/questionnaire/index'
import Answer from '@/pages/questionnaire/answer/index'
import AnswerDetails from '@/pages/questionnaire/answer/details'

export default [
  {
    path: '/questionnaire',
    name: 'questionnaire',
    component: Questionnaire,
    meta: { name: '问卷信息', keepAlive: false }
  },
  {
    path: '/answer',
    name: 'answer',
    component: Answer,
    meta: { name: '数据详情', keepAlive: false }
  },
  {
    path: '/answerDetails',
    name: 'answerDetails',
    component: AnswerDetails,
    meta: { name: '查看答券', keepAlive: false }
  },
]



// WEBPACK FOOTER //
// ./src/router/questionnaire/agOrderList.js